import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/Constants";
/**
 * ChanceGameParamsData.ts
 */
export class ChanceGameParamsData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.multiplier = this.data.getNumber(ApiConstants.PROPERTY_MULTIPLIER);
        }
    }
    getMultiplier() {
        return this.multiplier;
    }
}
export class BaseChanceGameData extends SolidifyableData {
    // data: chanceGame
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getNumber(ApiConstants.PROPERTY_ID);
            this.stake = this.data.getNumber(ApiConstants.PROPERTY_STAKE);
            this.totalWin = this.data.getNumber(ApiConstants.PROPERTY_TOTAL_WIN);
            this.currencyCode = this.data.getString(SlingoConstants.PROPERTY_CURRENCY);
            const gameConfig = this.data.getDataObject(ApiConstants.PROPERTY_GAME_CONFIG);
            this.gameId = gameConfig.getString(ApiConstants.PROPERTY_GAME_CONFIG_ID);
        }
    }
    solidifyGame() {
        const games = this.data.getDataArray(ApiConstants.PROPERTY_GAMES);
        if (!games || games.length === 0 || !games[0]) {
            throw new Error("Invalid games dataArray");
        }
        return games[0];
    }
    getId() {
        return this.id;
    }
    getGameConfigId() {
        return this.gameId;
    }
    getStake() {
        return this.stake;
    }
    getTotalWin() {
        return this.totalWin;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
}
export var GreenFishPrizeType;
(function (GreenFishPrizeType) {
    GreenFishPrizeType["CASH"] = "GreenFishPrizeType.CASH";
    GreenFishPrizeType["AWARD_ALL"] = "GreenFishPrizeType.AWARD_ALL";
})(GreenFishPrizeType || (GreenFishPrizeType = {}));
export class GreenFishChanceGameData extends BaseChanceGameData {
    getPickedPrize() {
        return this.pickedPrize;
    }
    getMissedPrizes() {
        return this.missedPrizes;
    }
    getIsCollectAll() {
        return this.isCollectAll;
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const game = this.solidifyGame();
            const payout = game.getNumberArray(ApiConstants.PROPERTY_PAYOUT);
            this.isCollectAll = payout.length > 1;
            if (this.isCollectAll) {
                this.pickedPrize = this.convertToGreenFishPrize(-1);
                this.missedPrizes = payout.map(prizeValue => this.convertToGreenFishPrize(prizeValue));
            }
            else {
                const pickedPrizeValue = payout[0];
                const params = game.getDataObject(ApiConstants.PROPERTY_PARAMS);
                const missedPrizeValues = params.getNumberArray(ApiConstants.PROPERTY_PARAMS_MISSED);
                this.pickedPrize = this.convertToGreenFishPrize(pickedPrizeValue);
                this.missedPrizes = missedPrizeValues.map(prizeValue => this.convertToGreenFishPrize(prizeValue));
            }
        }
    }
    convertToGreenFishPrize(prizeValue) {
        const type = prizeValue === -1 ? GreenFishPrizeType.AWARD_ALL : GreenFishPrizeType.CASH;
        const value = prizeValue;
        return { type, value };
    }
}
export var RedFishKissType;
(function (RedFishKissType) {
    RedFishKissType["green"] = "green";
    RedFishKissType["purple"] = "purple";
    RedFishKissType["blue"] = "blue";
    RedFishKissType["gold"] = "gold";
})(RedFishKissType || (RedFishKissType = {}));
;
export class RedFishChanceGameData extends BaseChanceGameData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            // for some reason redfish has 2 games[] object, which don't contain any useful information
            const params = this.data.getDataObject(ApiConstants.PROPERTY_PARAMS);
            this.initialPickValue = this.data.getNumberArray(ApiConstants.PROPERTY_PAYOUT)[0];
            this.initialPickMissedValues = params
                .getDataArray(ApiConstants.PROPERTY_PARAMS_MISSES)
                .map(missed => missed.getNumber(ApiConstants.PROPERTY_TOTAL_WIN));
            const kissTypesWithoutInitial = params.getStringArray(ApiConstants.PROPERTY_TYPE).slice(1);
            const rawPayouts = this.data.getNumberArray(ApiConstants.PROPERTY_PAYOUT);
            const payoutsWithoutInitial = rawPayouts.slice(1);
            const cumulativePayouts = rawPayouts.map((value, index, payouts) => {
                return payouts.slice(0, index + 1)
                    .reduce((a, b) => {
                    if (b === 0) { // gold fish kiss payout is 0
                        return a * 2;
                    }
                    else {
                        return a + b;
                    }
                }, 0);
            });
            const cumulativePayoutsWithoutInitial = cumulativePayouts.slice(1);
            this.kisses = kissTypesWithoutInitial.map((type, index) => {
                if (RedFishKissType[type] === undefined) {
                    throw new Error(`Invalid RedFishKissType: ${type}`);
                }
                return {
                    type: RedFishKissType[type],
                    value: payoutsWithoutInitial[index],
                    prevCumulativeValue: cumulativePayoutsWithoutInitial[index - 1] || this.initialPickValue,
                    cumulativeValue: cumulativePayoutsWithoutInitial[index]
                };
            });
        }
    }
    getInitialPickValue() {
        return this.initialPickValue;
    }
    getInitialPickMissedValues() {
        return this.initialPickMissedValues;
    }
    getKisses() {
        return this.kisses;
    }
}
export class PurpleFishChanceGameData extends BaseChanceGameData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const game = this.solidifyGame()
                .getDataArray(ApiConstants.PROPERTY_GAMES)[0]
                .getDataArray(ApiConstants.PROPERTY_GAMES)[0];
            const stake = game.getNumber(ApiConstants.PROPERTY_STAKE);
            const initialPickGameConfig = game.getDataObject(ApiConstants.PROPERTY_GAME_CONFIG);
            this.initialPickValue = initialPickGameConfig.getNumber(ApiConstants.PROPERTY_MULTIPLIER) * stake;
            let payouts = game.getNumberArray(ApiConstants.PROPERTY_PAYOUT);
            const rawPayouts = payouts.map(payout => Math.round(payout * (1 / stake)));
            const cumulativeMultiplierBubbleValues = rawPayouts.map((_, index, payouts) => {
                return payouts.slice(0, index + 1).reduce((a, b) => a + b, 0);
            });
            this.multiplierBubbles = cumulativeMultiplierBubbleValues.map((currentCumulativeValue, i, cumulativeValues) => {
                const payoutDigitArray = rawPayouts[i].toString().split("");
                let position = 0; // first digit is always middle
                if (i === 1) { // second stage can go left or right, depending on the raw first digit
                    const previousDigitLength = rawPayouts[0].toString().length;
                    if (payoutDigitArray.length > previousDigitLength) {
                        position = 0;
                    }
                    else {
                        position = 1;
                    }
                }
                else if (i === 2) { // third stage can go left, middle, or right
                    if (payoutDigitArray.length > 2) {
                        position = 0;
                    }
                    else if (payoutDigitArray.length > 1) {
                        position = 1;
                    }
                    else {
                        position = 2;
                    }
                }
                return {
                    newValue: parseInt(payoutDigitArray[0]),
                    position,
                    value: currentCumulativeValue
                };
            });
            const params = this.data.getDataObject(ApiConstants.PROPERTY_PARAMS);
            this.initialPickMissedValues = params.getDataArray(ApiConstants.PROPERTY_PARAMS_MISSES).map(miss => {
                return miss.getDataObject(ApiConstants.PROPERTY_GAME_CONFIG).getNumber(ApiConstants.PROPERTY_MULTIPLIER) * stake;
            });
        }
    }
    getInitialPickValue() {
        return this.initialPickValue;
    }
    getMultiplierBubbles() {
        return this.multiplierBubbles;
    }
    getInitialPickMissedValues() {
        return this.initialPickMissedValues;
    }
}
export var FishFoodType;
(function (FishFoodType) {
    FishFoodType["Turtle"] = "Turtle";
    FishFoodType["Blue"] = "Blue";
    FishFoodType["Red"] = "Red";
    FishFoodType["Green"] = "Green";
    FishFoodType["Purple"] = "Purple";
    FishFoodType["Gold"] = "Gold";
})(FishFoodType || (FishFoodType = {}));
export class FishFoodChanceGameData extends BaseChanceGameData {
    // data: chanceGame
    constructor(data) {
        super(data);
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const game = this.solidifyGame();
            const pickPayouts = this.data.getNumberArray(ApiConstants.PROPERTY_PAYOUT);
            const payoutValuesSeen = new Map();
            const winningPickPayouts = pickPayouts.map(payout => {
                payoutValuesSeen.set(payout, (payoutValuesSeen.get(payout) || 0) + 1);
                if (payoutValuesSeen.get(payout) > 2) {
                    return payout;
                }
                else {
                    return 0;
                }
            });
            let cumulativePayout = 0;
            const cumulativePickPayouts = winningPickPayouts.map(payout => {
                cumulativePayout += payout;
                return cumulativePayout;
            });
            const params = this.data.getDataObject(ApiConstants.PROPERTY_PARAMS);
            const fishFoodPrizes = params.getDataObject(ApiConstants.PROPERTY_PARAMS_FISH_FOOD_PRIZES);
            this.prizes = new Map(Object.entries(fishFoodPrizes.toObject()));
            const pickTypes = params.getStringArray(ApiConstants.PROPERTY_TYPE);
            const typeSeen = new Map();
            const typeCount = pickTypes.map(payout => {
                typeSeen.set(payout, (typeSeen.get(payout) || 0) + 1);
                return typeSeen.get(payout);
            });
            this.prizePicks = winningPickPayouts.map((payout, index, winningPickPayouts) => ({ pickCount: typeCount[index], pickPayout: payout, cumulativePayout: cumulativePickPayouts[index], type: pickTypes[index], lastPick: index === winningPickPayouts.length - 1 }));
            const turtleParams = game.getDataObject(ApiConstants.PROPERTY_PARAMS);
            this.turtlePickAmount = game.getNumberArray(ApiConstants.PROPERTY_PAYOUT)[0];
            this.turtleMissedPickAmounts = turtleParams.getNumberArray(ApiConstants.PROPERTY_PARAMS_MISSES);
            const allWinningTypes = [FishFoodType.Blue, FishFoodType.Red, FishFoodType.Green, FishFoodType.Purple, FishFoodType.Gold];
            this.goldTurtles = allWinningTypes.every(type => typeSeen.get(type) === 4); // if you get 4 of every fish, it ends in a gold turtle pick with increased prize values
            const missedPicks = new Map();
            Object.values(FishFoodType).forEach(type => {
                missedPicks.set(type, type === FishFoodType.Turtle ? 5 : 4);
            });
            typeSeen.forEach((count, type) => {
                missedPicks.set(type, missedPicks.get(type) - count);
            });
            this.missedPicks = missedPicks;
        }
    }
    getPrizePicks() {
        return this.prizePicks;
    }
    getMissedPicks() {
        return this.missedPicks;
    }
    getTurtlePickAmount() {
        return this.turtlePickAmount;
    }
    getTurtleMissedPickAmounts() {
        return this.turtleMissedPickAmounts;
    }
    getPrizes() {
        return this.prizes;
    }
    isGoldTurtle() {
        return this.goldTurtles;
    }
}
export class GoldFishChanceGameData extends BaseChanceGameData {
    constructor(data) {
        super(data);
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const params = this.data.getDataObject(ApiConstants.PROPERTY_PARAMS);
            this.baseSpins = params.getNumber(ApiConstants.PROPERTY_PARAMS_INITIAL_PICKS);
            this.baseGoldfish = params.getNumber(ApiConstants.PROPERTY_PARAMS_INITIAL_GOLDFISH);
            this.spinCount = params.getNumber(ApiConstants.PROPERTY_PARAMS_PICKS);
            this.goldFishCount = params.getNumber(ApiConstants.PROPERTY_PARAMS_GOLDFISH);
            const initialSpinsReward = this.spinCount - this.baseSpins;
            if (initialSpinsReward > 0) {
                this.pickReward = { type: "EXTRA_SPINS", count: initialSpinsReward };
            }
            else {
                this.pickReward = { type: "EXTRA_GOLDFISH" };
            }
            const missedBubbles = params.getDataArray(ApiConstants.PROPERTY_PARAMS_MISSED_BUBBLES);
            this.missedPickRewards = missedBubbles.map(missedBubble => {
                const missedExtraSpins = missedBubble.getNumber(ApiConstants.PROPERTY_PARAMS_MISSED_BUBBLE_TOTAL_PICKS) - this.baseSpins;
                if (missedExtraSpins > 0) {
                    return { type: "EXTRA_SPINS", count: missedExtraSpins };
                }
                else {
                    return { type: "EXTRA_GOLDFISH" };
                }
            });
            this.spins = params.getDataArray(ApiConstants.PROPERTY_PARAMS_BONUS_GAME_DATA).map(gameData => gameData.toObject());
            const payouts = this.data.getNumberArray(ApiConstants.PROPERTY_PAYOUT);
            let cumulativeSpinWin = 0;
            this.spins.forEach((spin, spinIndex, spins) => {
                const startIndex = (spinIndex * 5) + 1;
                const endIndex = startIndex + 5;
                const spinPayout = payouts.slice(startIndex, endIndex);
                if (spinPayout.length !== 5) {
                    throw new Error("GoldFish Spin Payout Error");
                }
                spin.cumulativeSpinWins = [];
                spin.spinWinStages = [];
                for (let i = 0; i < spin.goldFishCounter; i++) {
                    cumulativeSpinWin += (spin.spinWin / spin.goldFishCounter);
                    spin.cumulativeSpinWins.push(cumulativeSpinWin);
                    spin.spinWinStages.push((spin.spinWin / spin.goldFishCounter) * (i + 1));
                }
                spin.payout = spinPayout;
                spin.unmultipiedPayout = spinPayout;
                spin.multipliedPayout = spinPayout.map(payout => payout * spin.blueFishCounter);
                spin.multipliers = []; // track all multiplier changes so they can be displayed with each blue fish collected. spin.blueFish counter _is_ the final multipler value. spin.blueFish === 0 just means no multiplier applied (or 1x by default)
                // start tracking at 1x (or whatever the count beforeSpin was + 1) so as to only track one change, per bluefish on the reel
                for (let multiplier = spin.blueFishCounterBeforeSpin + 1; multiplier <= spin.blueFishCounter; multiplier++) {
                    spin.multipliers.push(multiplier);
                }
                if (spin.respinTriggered) {
                    const lockedReels = [];
                    spin.type.forEach((type, reelIndex) => {
                        if (type !== "BLUE" && type !== "BLANK" && type !== "GOLD") {
                            lockedReels.push(reelIndex);
                        }
                    });
                    spins[spinIndex + 1].lockedReels = lockedReels;
                }
                if (!spin.lockedReels) {
                    spin.lockedReels = [];
                }
            });
        }
    }
    getBaseSpins() {
        return this.baseSpins;
    }
    getSpinCount() {
        return this.spinCount;
    }
    getBaseGoldFish() {
        return this.baseGoldfish;
    }
    getGoldFishCount() {
    }
    getPickReward() {
        return this.pickReward;
    }
    getMissedPickRewards() {
        return this.missedPickRewards;
    }
    getSpinsData() {
        return this.spins;
    }
}
//# sourceMappingURL=ChanceGamesData.js.map